import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=0690acc2"
import script from "./AdminProfile.vue?vue&type=script&lang=ts"
export * from "./AdminProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0690acc2')) {
      api.createRecord('0690acc2', component.options)
    } else {
      api.reload('0690acc2', component.options)
    }
    module.hot.accept("./AdminProfile.vue?vue&type=template&id=0690acc2", function () {
      api.rerender('0690acc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/roles/AdminProfile.vue"
export default component.exports